/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-05-20 14:30:34
 * @LastEditTime: 2022-03-10 10:49:04
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
//rem布局解决方案
import 'lib-flexible'
//清空css默认样式
import '@/assets/css/reset.css'
//icon图标
import '@/assets/icon/iconfont.css'
import 'babel-polyfill'
import VeLine from 'v-charts/lib/line.common'
import ECharts from 'vue-echarts' // 在 webpack 环境下指向 components/ECharts.vue
// 手动引入 ECharts 各模块来减小打包体积
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import i18n from './common/lang/index'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
// import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
// 引用markerCluster中的文件
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"
import "leaflet.markercluster"
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
Vue.use(VueVideoPlayer)
Vue.component(VeLine.name, VeLine)
Vue.component('v-chart', ECharts)
    //顶部加载条
    // Vue.component(VeLine.name, VeLine)
    //顶部加载条配置
    //地图默认显示配置 (zh-CN:高德,en-US:'谷歌')
Vue.prototype.Map = 'zh-CN'
// Vue.prototype.Map = 'en-US'
// 解决leaflet图标失效的问题
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
router.beforeEach((to, from, next) => {
        NProgress.start();
        // 中断之前的所有请求
        store.dispatch('clearToken')
        next()
    })
    //顶部加载条配置
router.afterEach(transition => {
        NProgress.done();
    })
    // Vue.use(VCharts)x
new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')